import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialMonitorState: Dtos.Monitor & IRegistrationFormState = {
    id: null,
    monitoringId: null,
    monitoring: null,
    personnelId: null,
    personnel: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false,
}

export interface IMonitorReduxFormState {
    id: IFieldState<number>,
    monitoringId: IFieldState<number>,
    monitoring: IFieldState<Dtos.Monitoring>,
    personnelId: IFieldState<number>,
    personnel: IFieldState<Dtos.Personnel>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>,
    saveAndReturn: IFieldState<boolean>,
}
